import * as ambassadorWixEcomV1LocalDeliveryOption from './ecom-v1-local-delivery-option-local-delivery-options.http.js';
import * as ambassadorWixEcomV1LocalDeliveryOptionTypes from './ecom-v1-local-delivery-option-local-delivery-options.types.js';
import * as ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createLocalDeliveryOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.CreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.CreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.CreateLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.CreateLocalDeliveryOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.createLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLocalDeliveryOption(): __PublicMethodMetaInfo<
  'GET',
  { localDeliveryOptionId: string },
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.GetLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.GetLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.GetLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.GetLocalDeliveryOptionResponse
> {
  const payload = { localDeliveryOptionId: ':localDeliveryOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.getLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/local-delivery-options/{localDeliveryOptionId}',
    pathParams: { localDeliveryOptionId: 'localDeliveryOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listLocalDeliveryOptions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.ListLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.ListLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.ListLocalDeliveryOptionsResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.ListLocalDeliveryOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.listLocalDeliveryOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/localDeliveryOptions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLocalDeliveryOptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.QueryLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.QueryLocalDeliveryOptionsRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.QueryLocalDeliveryOptionsResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.QueryLocalDeliveryOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.queryLocalDeliveryOptions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLocalDeliveryOption(): __PublicMethodMetaInfo<
  'PATCH',
  { localDeliveryOptionId: string },
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.UpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.UpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.UpdateLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.UpdateLocalDeliveryOptionResponse
> {
  const payload = {
    localDeliveryOption: { id: ':localDeliveryOptionId' },
  } as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.updateLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/local-delivery-options/{localDeliveryOption.id}',
    pathParams: { localDeliveryOptionId: 'localDeliveryOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteLocalDeliveryOption(): __PublicMethodMetaInfo<
  'DELETE',
  { localDeliveryOptionId: string },
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.DeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.DeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.DeleteLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.DeleteLocalDeliveryOptionResponse
> {
  const payload = { localDeliveryOptionId: ':localDeliveryOptionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.deleteLocalDeliveryOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/local-delivery-options/{localDeliveryOptionId}',
    pathParams: { localDeliveryOptionId: 'localDeliveryOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateLocalDeliveryOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkCreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkCreateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkCreateLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkCreateLocalDeliveryOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.bulkCreateLocalDeliveryOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/local-delivery-options/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateLocalDeliveryOption(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkUpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkUpdateLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkUpdateLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkUpdateLocalDeliveryOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.bulkUpdateLocalDeliveryOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/bulk/local-delivery-options/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteLocalDeliveryOption(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkDeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkDeleteLocalDeliveryOptionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.BulkDeleteLocalDeliveryOptionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.BulkDeleteLocalDeliveryOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.bulkDeleteLocalDeliveryOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/local-delivery-options/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.AddDeliveryRegionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.AddDeliveryRegionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.addDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options/add-delivery-region',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1LocalDeliveryOptionUniversalTypes.RemoveDeliveryRegionResponse,
  ambassadorWixEcomV1LocalDeliveryOptionTypes.RemoveDeliveryRegionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1LocalDeliveryOption.removeDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/local-delivery-options/remove-delivery-region',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LocalDeliveryOption as LocalDeliveryOptionOriginal,
  LocalDeliveryOptionConfigOneOf as LocalDeliveryOptionConfigOneOfOriginal,
  Destination as DestinationOriginal,
  ZipCodeConfig as ZipCodeConfigOriginal,
  RadiusConfig as RadiusConfigOriginal,
  LocalDeliveryAddress as LocalDeliveryAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  LengthUnit as LengthUnitOriginal,
  LengthUnitWithLiterals as LengthUnitWithLiteralsOriginal,
  CustomAreaConfig as CustomAreaConfigOriginal,
  CityConfig as CityConfigOriginal,
  CityItem as CityItemOriginal,
  ScheduledDelivery as ScheduledDeliveryOriginal,
  Days as DaysOriginal,
  DaySlot as DaySlotOriginal,
  TimeSlot as TimeSlotOriginal,
  TimePoint as TimePointOriginal,
  TimeWindow as TimeWindowOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  TimeOfDay as TimeOfDayOriginal,
  ConditionalRates as ConditionalRatesOriginal,
  Condition as ConditionOriginal,
  ConditionType as ConditionTypeOriginal,
  ConditionTypeWithLiterals as ConditionTypeWithLiteralsOriginal,
  LogicalOperator as LogicalOperatorOriginal,
  LogicalOperatorWithLiterals as LogicalOperatorWithLiteralsOriginal,
  CreateLocalDeliveryOptionRequest as CreateLocalDeliveryOptionRequestOriginal,
  CreateLocalDeliveryOptionResponse as CreateLocalDeliveryOptionResponseOriginal,
  GetLocalDeliveryOptionRequest as GetLocalDeliveryOptionRequestOriginal,
  GetLocalDeliveryOptionResponse as GetLocalDeliveryOptionResponseOriginal,
  ListLocalDeliveryOptionsRequest as ListLocalDeliveryOptionsRequestOriginal,
  ListLocalDeliveryOptionsResponse as ListLocalDeliveryOptionsResponseOriginal,
  QueryLocalDeliveryOptionsRequest as QueryLocalDeliveryOptionsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLocalDeliveryOptionsResponse as QueryLocalDeliveryOptionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateLocalDeliveryOptionRequest as UpdateLocalDeliveryOptionRequestOriginal,
  UpdateLocalDeliveryOptionResponse as UpdateLocalDeliveryOptionResponseOriginal,
  DeleteLocalDeliveryOptionRequest as DeleteLocalDeliveryOptionRequestOriginal,
  DeleteLocalDeliveryOptionResponse as DeleteLocalDeliveryOptionResponseOriginal,
  BulkCreateLocalDeliveryOptionRequest as BulkCreateLocalDeliveryOptionRequestOriginal,
  BulkCreateLocalDeliveryOptionResponse as BulkCreateLocalDeliveryOptionResponseOriginal,
  LocalDeliveryOptionError as LocalDeliveryOptionErrorOriginal,
  BulkUpdateLocalDeliveryOptionRequest as BulkUpdateLocalDeliveryOptionRequestOriginal,
  BulkUpdateLocalDeliveryOptionResponse as BulkUpdateLocalDeliveryOptionResponseOriginal,
  BulkDeleteLocalDeliveryOptionRequest as BulkDeleteLocalDeliveryOptionRequestOriginal,
  BulkDeleteLocalDeliveryOptionResponse as BulkDeleteLocalDeliveryOptionResponseOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  AddDeliveryRegionRequest as AddDeliveryRegionRequestOriginal,
  AddDeliveryRegionResponse as AddDeliveryRegionResponseOriginal,
  RemoveDeliveryRegionRequest as RemoveDeliveryRegionRequestOriginal,
  RemoveDeliveryRegionResponse as RemoveDeliveryRegionResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateLocalDeliveryOptionApplicationErrors as CreateLocalDeliveryOptionApplicationErrorsOriginal,
  BulkCreateLocalDeliveryOptionApplicationErrors as BulkCreateLocalDeliveryOptionApplicationErrorsOriginal,
} from './ecom-v1-local-delivery-option-local-delivery-options.types.js';
